import { useMemo } from 'react';

import { getGroupedItems } from '../itemGroupingHelpers';
import { ReturnItem } from '../types';

export function useGroupedItems(items: ReturnItem[]) {
  return useMemo(() => getGroupedItems(items), [items]);
}
